import { EXPERIMENTS, createFormView, useExperiments, useConfig } from '@wix/form-fields';
import { useMemo } from 'react';
export const useFormView = (form, stepId, breakpoint) => {
  const {
    isMobile
  } = useConfig();
  const experiments = useExperiments();
  const useFieldsV2 = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2);
  return useMemo(() => {
    return ((form == null ? void 0 : form.steps) || []).filter(step => !stepId || stepId === step.id).map(step => {
      return createFormView({
        form,
        stepId: step.id,
        isMobile,
        breakpoint,
        useFieldsV2
      });
    });
  }, [form, stepId, isMobile, breakpoint, useFieldsV2]);
};
//# sourceMappingURL=use-form-view.js.map